import React from 'react';
import classNames from 'classnames';
import { Image } from '../../modules/image/image';
import { ImageTransformType, ImageType } from '../../modules/image/constants';
import styles from './picto.module.scss';

type Props = {
  className?: string;
  pictoSrc: string;
  size: '24' | '32';
};

export const Picto: React.FC<Props> = ({ className, pictoSrc, size }) => {
  return (
    <div className={classNames(styles.root, styles[`size${size}`], className)}>
      <Image baseSrc={pictoSrc} imageSizes={ImageTransformType.picto} type={ImageType.aspectRatio} />
    </div>
  );
};
